<template>
	<b-card header-tag="header">
		<template #header style="position: relative">
			<b-row>
				<b-col>
					<h4><b>Главное меню</b></h4>
				</b-col>
				<b-col @click="$router.push('/')">
					<img src="../../../assets/dutyFree.jpg"
						style="width: 185px; position: absolute; top: -10px; right: 25%" alt="">
				</b-col>
				<b-col align="right">
					<h4 class="mr-2"><b>@ {{ username }}</b></h4>
				</b-col>
				<b-col @click="logout" cols="1">
					<b-button size="sm">
						<i style="font-size: 15px" class="fas fa-sign-out-alt text-danger mr-1" /> <b>Выйти</b>
					</b-button>
				</b-col>
			</b-row>
		</template>
		<b-overlay :show="loading">
			<b-row>
				<b-col>
					<b-row class="mt-3">
						<b-col cols="5" align="center">
							<h4><b>{{ $t('promo-to-product.department') }}:</b></h4>
						</b-col>
						<b-col>
							<h4>{{ fiscalData.departmentName }}</h4>
						</b-col>
					</b-row>
				</b-col>
				<b-col>
					<b-row class="mt-3">
						<b-col cols="5" align="center">
							<h4><b>{{ $t('kassa.nomer') }}:</b></h4>
						</b-col>
						<b-col>
							<h4>{{ fiscalData.name }}</h4>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="4">
					<div class="mt-3 d-flex flex-row justify-content-around align-items-center gap-4">
						<b-button style="width: 80px" v-if="isNewXumo === 'true'"
							class="d-flex flex-column text-center justify-content-center align-items-center text-white"
							@click="confirmEndTerminal = true" variant="warning">
							<i class="fa fa-credit-card mb-1" />
							Терминал
						</b-button>
						<b-button style="width: 80px"
							class="d-flex flex-column text-center justify-content-center align-items-center"
							@click="sendCheckKKM()" variant="success">
							<i class="fa fa-print mb-1" />
							ККМ
						</b-button>
						<b-button style="position: relative; width: 80px"
							class="d-flex flex-column text-center justify-content-center align-items-center text-white"
							@click="openOrders" variant="info">
							<i class="fa fa-shopping-bag mb-1" />
							Заказы
							<b-badge style="position: absolute; top: -5px; right: -5px"
								:variant="orders && orders.length === 0 ? 'success' : 'danger'">{{ orders.length }}
							</b-badge>
						</b-button>
					</div>
				</b-col>
			</b-row>
			<b-row class="mt-5">
				<b-col>
					<b-button @click="$router.push('/point-of-sale/transfer-income')"
						style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-cloud-download text-info mb-3" />
						<h5><b>Приход</b></h5>
					</b-button>
				</b-col>
				<b-col>
					<b-button @click="$router.push('/warehouse-management/warehouses-for-pos')"
						style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-home text-primary mb-3" />
						<h5><b>Остатка</b></h5>
					</b-button>
				</b-col>
				<b-col>
					<b-button
						@click="$router.push(`/point-of-sale/sales-for-seller/${fiscalData.departmentId}/${fiscalData.id}`)"
						style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-list text-dark mb-3" />
						<h5><b>Список Продаж</b></h5>
					</b-button>
				</b-col>
				<b-col>
					<b-button @click="$router.push(`/point-of-sale/kpi/${fiscalData.departmentId}`)"
						style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-list-alt text-dark mb-3" />
						<h5><b>KPI</b></h5>
					</b-button>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-2">
				<b-col>
					<b-button @click="xreportOpen" style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-close text-success mb-3" />
						<h5><b>Х-отчёт</b></h5>
					</b-button>
				</b-col>
				<b-col>
					<b-button
						@click="$can('perm', 'return') ? returnComponentModal = true : $vs.notify({ title: 'У вас нет доступа !', color: 'danger', icon: 'close', position: 'top-right' })"
						style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-undo text-success mb-3" />
						<h5><b>Возврат</b></h5>
					</b-button>
				</b-col>
				<b-col>
					<b-button @click="toPos" style="width: 100%; padding: 40px; height: 100%">
						<i style="font-size: 40px" class="fa fa-plus-circle text-primary mb-3" />
						<h5><b>Начать Продажу</b></h5>
					</b-button>
				</b-col>
				<b-col>
					<b-button @click="terminalReportCheck" style="width: 100%; padding: 40px; height: 100%">
						<p style="font-size: 35px" class="text-danger mb-1"><b>Z</b></p>
						<h5><b>Z-отчёт</b></h5>
					</b-button>
				</b-col>
			</b-row>
		</b-overlay>

		<!-- Order Modal -->
		<b-modal v-model="orderModal" size="lg" title="Онлайн заказы" hide-footer>
			<b-list-group v-for="(item, index) in orders" :key="`order-${index}`">
				<b-list-group-item v-b-toggle="'order-' + index" style="cursor: pointer">
					<b>{{ index + 1 }}.</b>
					<span class="mx-4">{{ item.orderNumber }}</span>
					<b class="ml-3">Дата заказа:</b><span class="ml-1 mr-3">{{ item.orderDate }}</span>
					<b>Дата выдачи заказа:</b><span class="mx-1">{{ item.pickupDate }}</span>
				</b-list-group-item>
				<b-collapse :id="`order-${index}`" accordion="order" @show="getOrderItems(item, index)">
					<b-table-simple>
						<b-thead>
							<b-tr>
								<b-th class="text-center">№</b-th>
								<b-th class="text-center">{{ $t('goods.barcode') }}</b-th>
								<b-th class="text-center">{{ $t('incomes.create.product') }}</b-th>
								<b-th class="text-center">{{ $t('air_cafe.category') }}</b-th>
								<b-th class="text-center">{{ $t('sale.kol-vo') }}</b-th>
							</b-tr>
						</b-thead>
						<b-tbody v-if="item.orderItemDtoList && item.orderItemDtoList.length">
							<b-tr v-for="(tmp, ind) in item.orderItemDtoList" :key="`order-items-${ind}`">
								<b-td class="text-center">{{ ind + 1 }}</b-td>
								<b-td class="text-center">{{ tmp.itemDto.barcode }}</b-td>
								<b-td class="text-center">{{ tmp.itemDto.name }}</b-td>
								<b-td class="text-center">{{ tmp.itemDto.subCategoryName }} /
									{{ tmp.itemDto.sub2CategoryName }}
								</b-td>
								<b-td class="text-center">{{ tmp.count }}</b-td>
							</b-tr>
							<b-tr>
								<b-td colspan="5" class="text-right p-2">
									<b-button @click="changeOrder(item)" size="sm" variant="success">
										<b-spinner v-if="loading" class="mr-2" variant="primary" size="sm" />
										Упаковано и готово
									</b-button>
								</b-td>
							</b-tr>
						</b-tbody>
						<b-tbody v-else>
							<b-tr>
								<b-td colspan="5" class="text-center p-4">
									<b-spinner variant="primary" />
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-collapse>
			</b-list-group>
		</b-modal>

		<!-- TERMINAL END CONFIRM MODAL -->
		<b-modal centered v-model="confirmEndTerminal" @ok="humoClose"
			@cancel="confirmEndTerminal = !confirmEndTerminal" ok-title="Да" cancel-title="Отмена">
			Вы хотите закрыть день на терминале. Вы уверены?
		</b-modal>

		<!-- Z-REPORT END SESSION MODAL -->
		<b-modal v-model="confirmEndSession" @ok="closeAndPrintZReport" @cancel="confirmEndSession = !confirmEndSession"
			ok-title="Да" cancel-title="Отмена">
			<h4>{{ $t('zOtchet.title') }}</h4>
		</b-modal>

		<!-- Z-REPORT VIEW MODAL -->
		<b-modal v-model="zreport" size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true"
			hide-header class="body-padding-0">
			<x-and-z-report v-if="zreport" is-z-report @close="closeZreport"></x-and-z-report>
		</b-modal>

		<!-- X-REPORT VIEW MODAL -->
		<b-modal v-model="xreport" size="lg" hide-footer hide-header :no-close-on-esc="true"
			:no-close-on-backdrop="true" class="body-padding-0">
			<x-and-z-report v-if="xreport" @close="closeXreport"></x-and-z-report>
		</b-modal>

		<!-- RETURN MODAL -->
		<b-modal v-model="returnComponentModal" size="lg" hide-footer hide-header :no-close-on-esc="true"
			:no-close-on-backdrop="true">
			<template>
				<return-component :mode="'retail'" :show-return-modal="returnComponentModal"
					@close="closeReturnModal" />
			</template>
		</b-modal>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import XAndZReport from "@/views/point-of-sale/pos/components/Xreport/XAndZReport";
import ReturnComponent from "@/views/return-component/ReturnComponent";
import { mapActions, mapGetters, mapState } from 'vuex'
import { TokenService } from "../../../services/storage.service";
import { BOverlay, BTableSimple, BTbody, BTd, BTh, BThead, BTr } from "bootstrapVue2";
import FBoxService from "../../../services/fbox.service";
import PosService from "../../../services/pos.service";
import ApiService from "@/services/api.service";

export default {
	name: "before_pos",
	components: { Multiselect, XAndZReport, ReturnComponent, BOverlay, BTableSimple, BThead, BTbody, BTr, BTh, BTd },
	data() {
		return {
			loading: false,
			selectedDepForSearch: null,
			cashboxList: [],
			selectedDep: null,
			refInputNotFilled: false,
			modalForAdding: false,
			cashboxnumber: '',
			show: false,
			errorShow: false,
			confirmEndTerminal: false,
			cashboxId: null,
			savedCashboxId: null,
			confirmEndSession: false,
			zreport: false,
			xreport: false,
			returnComponentModal: false,
			isNewXumo: localStorage.getItem('is_new_xumo'),
			isNewUzcard: localStorage.getItem('is_new_uzcard'),
			fiscalData: {},
			orders: [],
			orderModal: false
		}
	},
	computed: {
		...mapGetters('departments', ['myDepartments']),
		...mapState("zetReport", ["currentReport"]),
		username() {
			return TokenService.getUserName();
		}
	},
	watch: {
		'fiscalData': {
			handler(d) {
				localStorage.setItem('cash_id', d.id)
				localStorage.setItem('dep_id', d.departmentId)
				localStorage.setItem('dep_name', d.departmentName)
				localStorage.setItem('ip_address', d.ipAddress)
				localStorage.setItem('cash_number', d.name)
				localStorage.setItem('is_bar', d.isBar)
				localStorage.setItem('is_new_xumo', d.isNewXumo)
				localStorage.setItem('is_new_uzcard', d.isNewUzcard)
				localStorage.setItem('is_sky_shop', d.isSkyShop)
			}
		}
	},
	methods: {
		...mapActions('departments', ['fetchMyDepartments']),
		...mapActions('zetReport', ['startSessionToDep', 'getCurrentXReport']),
		closeReturnModal() {
			this.returnComponentModal = false;
		},
		async humoClose() {
			try {
				this.loading = true

				const { data: response } = await FBoxService.humoClose(localStorage.getItem('ip_address'), localStorage.getItem('cash_id'))

				if (response) {
					this.$vs.notify({
						time: 1000,
						title: 'Успешно!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}
			} catch (error) {
				console.log(error)
				// if (error.request && error.request.response && error.request.response !== "") {
				// 	this.$bvModal.msgBoxOk(JSON.parse(error.request.response).message, {
				// 		size: 'sm',
				// 		centered: true,
				// 		hideHeader: true,
				// 		noCloseOnEsc: true,
				// 		okVariant: 'success',
				// 		noCloseOnBackdrop: true,
				// 		footerClass: 'bg-dager',
				// 		bodyClass: 'bg-dager h3 bold'
				// 	}).then(value => {
				// 	})
				// } else {
				// 	this.$bvModal.msgBoxOk(error.message, {
				// 		size: 'sm',
				// 		centered: true,
				// 		hideHeader: true,
				// 		noCloseOnEsc: true,
				// 		okVariant: 'success',
				// 		noCloseOnBackdrop: true,
				// 		footerClass: 'bg-dager',
				// 		bodyClass: 'bg-dager h3 bold'
				// 	}).then(value => {
				// 	})
				// }
			} finally {
				this.loading = false
			}
		},
		async terminalReportCheck() {
			this.confirmEndSession = true
			// 	if (this.isNewXumo === 'true') {
			// 	this.loading = true
			// 	await PosService.terminalReportCheck(localStorage.getItem('cash_id')).then(async (res) => {
			// 		if (!res.data) {
			// 			this.confirmEndSession = true
			// 		} else {
			// 			this.$vs.notify({
			// 				title: 'Терминал не Закрыть',
			// 				color: 'danger',
			// 				icon: 'close',
			// 				position: 'top-right'
			// 			});
			// 		}
			// 	}).catch(er => {
			// 		this.$vs.notify({
			// 			title: er.message,
			// 			color: 'danger',
			// 			icon: 'close',
			// 			position: 'top-right'
			// 		});
			// 	}).finally(f => {
			// 		this.loading = false
			// 	})
			// } else {
			// 	this.confirmEndSession = true
			// }
		},
		async closeAndPrintZReport(okEvent) {
			this.loading = true
			await PosService.getKkmSaleCount(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).then(async (res) => {
				if (res.data === 0) {
					okEvent.preventDefault();
					if (!this.fiscalData.id) {
						this.$vs.notify({
							title: 'Продажа не было...',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
					await this.getCurrentXReport(this.fiscalData.departmentId)
					let resFromFBox = null;
					let errMsgFromFBox = null;
					try {
						resFromFBox = await FBoxService.xAndZReportCloseOrPrint({
							ipAddress: this.fiscalData.ipAddress,
							data: this.currentReport.payments,
							closeZReport: true,
							salesEur: this.currentReport.salesEuro,
							totalEur: this.currentReport.totalWithDiscount - this.currentReport.totalRefundAmount,
							sellerName: this.currentReport.cashierFullName,
							cashboxName: this.currentReport.cashboxName,
							depName: this.currentReport.departmentName
						});
					} catch (e) {
						if (e.request && e.request.response) {
							let response = JSON.parse(e.request.response);
							errMsgFromFBox = response.message;
						}
					}
					if (resFromFBox && resFromFBox.data.is_success) {
						this.confirmEndSession = false
						this.zreport = true
					} else {
						let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
						this.$vs.notify({
							title: fbError,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					this.$vs.notify({
						title: 'Сначала отправьте все чеки',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		xreportOpen() {
			if (!this.fiscalData.id) {
				this.$vs.notify({
					title: 'Пожалуста выберите кассу',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				return 0;
			} else {
				localStorage.setItem('cash_id', this.fiscalData.id)
				this.xreport = true
			}
		},
		async sendCheckKKM() {
			let ip_address = localStorage.getItem('ip_address')
			window.open(`${ip_address}/order/sendreceipt`)
		},
		closeZreport() {
			this.zreport = false
			this.$router.go()
			if (TokenService.getUserRoles() == 'seller') {
				this.$store.dispatch('logout')
			}
		},
		closeXreport() {
			this.xreport = false
		},
		async toPos() {
			if (this.fiscalData.departmentId && this.fiscalData.id) {
				// 	await FBoxService.getInfoFiscal().then(res => {
				// 		if (res.data.is_success === true) {
				this.$router.push(`/point-of-sale/pos-v2/${this.fiscalData.departmentId}/${this.fiscalData.id}`)
				// 	} else {
				// 		this.$vs.notify({
				// 			title: res.data.error.message,
				// 			color: 'danger',
				// 			icon: 'close',
				// 			position: 'top-right'
				// 		});
				// 	}
				// }).catch(e => {
				// 	this.$vs.notify({
				// 		title: e.message,
				// 		color: 'danger',
				// 		icon: 'close',
				// 		position: 'top-right'
				// 	});
				// })
			} else {
				this.$vs.notify({
					title: 'Пожалуста выберите кассу',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		logout() {
			this.$store.dispatch('logout')
		},
		openOrders() {
			this.getOrders();
			this.orderModal = true
		},
		async getOrders() {
			this.loading = true
			await ApiService.post(`/order/list-search/${this.fiscalData.departmentId}/ACCEPTED?search=`, {
				page: 1,
				limit: 100000
			}).then(res => {
				this.orders = res.data.items
			}).catch(e => {
				this.$vs.notify({
					title: (e.response && e.response.data && e.response.data.message) ? e.response.data.message : e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async getOrderItems(item, index) {
			this.loading = true
			await ApiService.get(`/order/get/${item.id}`).then(res => {
				this.orders[index].orderItemDtoList = res.data.orderItemDtoList ? res.data.orderItemDtoList : []
			}).catch(e => {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: (e.response && e.response.data && e.response.data.message) ? e.response.data.message : e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}).finally(f => {
				this.loading = false
			})
		},
		async changeOrder(order) {
			this.loading = true
			await ApiService.get(`/order/change-status/${order.id}?status=READY_FOR_PICKUP`).then(res => {
				this.getOrders();
				this.orderModal = false
			}).catch(e => {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: (e.response && e.response.data && e.response.data.message) ? e.response.data.message : e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}).finally(f => {
				this.loading = false
			})
		}
	},
	async created() {
		this.loading = true
		await FBoxService.getFiscalIpData().then(res => {
			this.fiscalData = res.data
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		}).finally(f => {
			this.loading = false
		})
		await this.getOrders();
		// await this.fetchMyDepartments();
		// let dep = localStorage.getItem('department')
		// if (this.myDepartments.length === 1) {
		// 	this.selectedDepForSearch = this.myDepartments[0]
		// 	localStorage.setItem('department', JSON.stringify(this.myDepartments[0]))
		// } else if (dep) {
		// 	this.selectedDepForSearch = JSON.parse(dep)
		// } else {
		// 	let userDep = this.myDepartments.find(dep => dep.id == this.userDepId)
		// 	this.selectedDepForSearch = userDep ? Object.assign({}, userDep) : null
		// }
		// await this.fetchCashboxList();
	}
}
</script>

<style scoped></style>
